import {
  ActionIcon,
  Anchor,
  Button,
  Container,
  Group,
  Stack,
  Text,
  TextInput,
  Title,
} from "@mantine/core";
import { Link } from "react-router-dom";
import { IconSearch } from "@tabler/icons-react";
import { useSessionStore } from "../../stores/UserStore";
import LogoHorizontalWhite from "../../layouts/LogoHorizontalWhite";
import SupportLanguageChanger from "./locales/SupportLanguageChanger";
import { useSupportLanguage } from "./stores/SupportLanguageStore";

const DemiCircle = ({ ...props }) => {
  return (
    <svg
      viewBox="0 0 127 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M63.5 128C98.5701 128 127 99.3462 127 64C127 28.6538 98.5701 0 63.5 0C28.4299 0 0 28.6538 0 64C0 99.3462 28.4299 128 63.5 128ZM64.0474 91.5862C78.8615 91.5862 90.8707 79.4825 90.8707 64.5517C90.8707 49.621 78.8615 37.5172 64.0474 37.5172C49.2333 37.5172 37.2241 49.621 37.2241 64.5517C37.2241 79.4825 49.2333 91.5862 64.0474 91.5862Z"
        fill="#FF7B9C"
      />
    </svg>
  );
};
const Rhombus = ({ ...props }) => {
  return (
    <svg
      viewBox="0 0 127 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.27628 75.6289C-1.42543 69.9272 -1.42542 60.6829 4.27629 54.9812L54.9812 4.27629C60.6829 -1.42542 69.9272 -1.42543 75.6289 4.27628L123.724 52.3711C129.425 58.0728 129.425 67.3171 123.724 73.0188L73.0188 123.724C67.3171 129.425 58.0728 129.425 52.3711 123.724L4.27628 75.6289Z"
        fill="#f3ff70"
      />
    </svg>
  );
};

const Header = () => {
  const lang = useSupportLanguage((s) => s.language);
  const reseller = useSessionStore((s) => s.reseller);
  return (
    <Group
      bg={
        reseller?.name === "Magileads"
          ? "#3A2C60"
          : reseller?.color_muted !== "A8A8A8"
          ? `#${reseller.color_muted}`
          : `linear-gradient(90deg, var(--mantine-color-primary-4), var(--mantine-color-primary-4))`
      }
      pb={16}
      pos={"relative"}
    >
      <DemiCircle
        style={{
          position: "absolute",
          left: "20%",
          top: "40%",
          width: 48,
        }}
      />
      <Rhombus
        style={{
          position: "absolute",
          right: "20%",
          top: "60%",
          width: 64,
        }}
      />
      <Container size={"xl"} w={"100%"}>
        <Stack gap={0}>
          <Group justify="space-between" p={"md"} w={"100%"} pt={"xl"}>
            <Link to={"/support"}>
              <Group h={64} maw={300}>
                <LogoHorizontalWhite w={"100%"} h={52} sm />
              </Group>
            </Link>

            <Group>
              <Button
                variant="subtle"
                component={Link}
                to={"/login"}
                color="#fcfbff"
                size="md"
              >
                {lang.header.login}
              </Button>
              {reseller?.contact_support && (
                <Button
                  variant="light"
                  color="#fcfbff"
                  component={Anchor}
                  underline="never"
                  href={`mailto:${reseller?.contact_support}`}
                >
                  {lang.header.contact_us}
                </Button>
              )}
              <SupportLanguageChanger />
            </Group>
          </Group>

          <Stack justify="center" align="center" pb={32} mt={48}>
            <Title order={1} c={"#fcfbff"}>
              {lang.header.title}
            </Title>

            <TextInput
              mt={"lg"}
              placeholder="Rehercher ..."
              radius={"sm"}
              size="lg"
              w={"45%"}
              rightSection={
                <ActionIcon radius={"sm"} size={"xl"} variant="subtle">
                  <IconSearch />
                </ActionIcon>
              }
              styles={{
                input: {
                  paddingLeft: 28,
                },
              }}
              readOnly
            />

            <Text c={"#fcfbff"}>
              {lang.header.popular_article}{" "}
              <Anchor
                c={"secondary.3"}
                component={Link}
                to={"/support/contact-lists/import-linkedin"}
              >
                {" "}
                {lang.header.popular_article_1}
              </Anchor>
            </Text>
          </Stack>
        </Stack>
      </Container>
    </Group>
  );
};

export default Header;
